var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBomb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bomb Threat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bomb_Threat",
    "data-name": "Bomb Threat",
    d: "M12.5,8A8.5,8.5,0,1,0,21,16.5,8.51,8.51,0,0,0,12.5,8ZM16,19l-1,1-2.5-2.51L10,20,9,19l2.51-2.5L9,14l1-1,2.5,2.51L15,13l1,1-2.51,2.5ZM21.65.64c-1.33,1.28-2.17.85-3.42.21A5.78,5.78,0,0,0,15.52,0,3.79,3.79,0,0,0,12,4H10.25A1.25,1.25,0,0,0,9,5.25V7.68a9.35,9.35,0,0,1,7,0V5.25A1.25,1.25,0,0,0,14.75,4H13a2.8,2.8,0,0,1,2.52-3,5,5,0,0,1,2.25.73c1.27.66,2.72,1.41,4.58-.37Z",
    fill: "#0e1d25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.4f6110bf96ae24acce8f45676cb47fac.svg";
export { ForwardRef as ReactComponent };